import { BottomTabNavigationProp } from '@react-navigation/bottom-tabs';
import { CompositeNavigationProp, useRoute } from '@react-navigation/native';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
  NativeStackScreenProps,
} from '@react-navigation/native-stack';
import React from 'react';

import HeaderStatusBar from 'app/components/HeaderStatusBar';
import useHeaderScreenOptions from 'app/hooks/useHeaderScreenOptions';
import { getRouteParam } from 'app/navigation/navigationHelper';
import { ProductTabParamList } from 'app/navigation/ProductTabNavigator';
import AttractionScreen from 'app/screens/AttractionScreen';
import AttractionTicketsScreen from 'app/screens/AttractionTicketsScreen';

export type {
  ProductTabParamList,
  ProductTabScreenCompositeProps as ProductTabScreenProps,
} from 'app/navigation/ProductTabNavigator';

export type AttractionTicketsStackParamList = {
  AttractionTickets: { productId: string };
  Attraction: { productId: string; attractionId: string };
};

export type AttractionTicketsStackScreenProps<
  Screen extends keyof AttractionTicketsStackParamList
> = NativeStackScreenProps<AttractionTicketsStackParamList, Screen>;

export type AttractionTicketsScreenNavigationProp = CompositeNavigationProp<
  BottomTabNavigationProp<ProductTabParamList>,
  NativeStackNavigationProp<AttractionTicketsStackParamList>
>;

const Stack = createNativeStackNavigator<AttractionTicketsStackParamList>();

export default function AttractionTicketsStackNavigator() {
  const route = useRoute();
  const productId = getRouteParam(route, 'productId') ?? '';
  const params = productId ? { productId } : undefined;
  const headerScreenOptions = useHeaderScreenOptions();

  return (
    <Stack.Navigator initialRouteName="AttractionTickets" screenOptions={headerScreenOptions}>
      <Stack.Screen
        component={AttractionTicketsScreen}
        initialParams={params}
        initialRouteName="AttractionTickets"
        /*
          Type '"AttractionTickets"' is not assignable to type '"Attraction"'.ts(2322)

          types.d.ts(349, 5): The expected type comes from property 'name' which is declared here on type 'IntrinsicAttributes & RouteConfig<AttractionTicketsStackParamList, "Attraction", StackNavigationState<ParamListBase>, NativeStackNavigationOptions, NativeStackNavigationEventMap>'
          */
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: the error shown above was introduced in 6.0.12 with no change on our side
        name="AttractionTickets"
        options={{ header: () => <HeaderStatusBar /> }}
      />

      <Stack.Screen
        component={AttractionScreen}
        initialParams={params}
        name="Attraction"
        options={{ headerShown: true }}
      />
    </Stack.Navigator>
  );
}
